import { render } from "./DoubleAuth.vue?vue&type=template&id=9d9a3afa&scoped=true"
import script from "./DoubleAuth.vue?vue&type=script&lang=js"
export * from "./DoubleAuth.vue?vue&type=script&lang=js"

import "./DoubleAuth.vue?vue&type=style&index=0&id=9d9a3afa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9a3afa"]])

export default __exports__